const NAMESPACE = "energystoragesubsystem";

const KEYS = {
    integratedEnergyStorageLabel: "integratedEnergyStorageLabel",
    deleteIntegratedEnergyStorageButtonLabel: "deleteIntegratedEnergyStorageButtonLabel",
    subsystemCloneButtonLabel: "subsystemCloneButtonLabel",
    inverterLabel: "inverterLabel",
    deleteInverterButtonLabel: "deleteInverterButtonLabel",
    inverterRequiresBatteryErrorMessage: "inverterRequiresBatteryErrorMessage",
    batteryLabel: "batteryLabel",
    deleteBatteryLabel: "deleteBatteryLabel",
    addBatteryButtonLabel: "addBatteryButtonLabel",
    updatedModelSuffix: "updatedModelSuffix"
};

const MESSAGES = {
    [KEYS.integratedEnergyStorageLabel]: {
        value: "Integrated Energy Storage",
        comment: "Label for integrated energy storage section"
    },
    [KEYS.deleteIntegratedEnergyStorageButtonLabel]: {
        value: "Delete Integrated Energy Storage",
        comment: "Label for button to delete integrated energy storage section"
    },
    [KEYS.subsystemCloneButtonLabel]: {
        value: "Clone System",
        comment: "Label for button to clone an entire subsystem including its children"
    },
    [KEYS.inverterLabel]: {
        value: "Inverter",
        comment: "Label for inverter section"
    },
    [KEYS.deleteInverterButtonLabel]: {
        value: "Delete Inverter",
        comment: "Label for button to delete inverter section"
    },
    [KEYS.inverterRequiresBatteryErrorMessage]: {
        value: "This inverter must have at least one Battery defined.",
        comment: "Error message displayed when a storage system inverter does not have any Batteries defined."
    },
    [KEYS.batteryLabel]: {
        value: "Battery",
        comment: "Label for battery section"
    },
    [KEYS.deleteBatteryLabel]: {
        value: "Delete Battery",
        comment: "Label for button to delete battery section"
    },
    [KEYS.addBatteryButtonLabel]: {
        value: "Add Battery",
        comment: "Label for button to add battery"
    },
    [KEYS.updatedModelSuffix]: {
        value: " - UPDATED",
        comment: "Suffix to use on a model definition which is an updated version of the stored model"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
